<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaEventTypes"
        title-table="Tipo de Evento"
        module="eventTypeSettingsModule"
        sort-name="nome"
        add-permission="ROLE_EVENTOS_INSERIR"
        view-permission="ROLE_EVENTOS_CONSULTAR"
        edit-permission="ROLE_EVENTOS_ATUALIZAR"
        delete-permission="ROLE_EVENTOS_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <EventTypeForm
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import EventTypeForm from './form/EventTypeForm.vue'

export default {
  name: 'EventTypeSetting',
  components: {
    BRow,
    BCol,
    TableComponents,
    EventTypeForm,
  },
  computed: {
    ...mapState('eventTypeSettingsModule', {
      listaEventTypes: state => state.listaEventTypes,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'id',
          field: 'id',
        },
        {
          label: 'Nome',
          field: 'nome',
        },
        {
          label: 'Ação',
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch(
        'eventTypeSettingsModule/prepareToEditEventType',
        data,
      )
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
